import { fetchFromServer, syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { simplePages } from "@/services/cache";
import { simplePagesSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { SimplePages } from "@tmi/types/api/content-models";
import type { SimplePageContent } from "@tmi/types/entities";

const config: DependencySyncConfig<SimplePages, SimplePageContent, SimplePageContent> = {
    name: 'simple-page',
    store: () => simplePages,
    syncKey: simplePagesSyncKey,
    throttle: { hours: 4 },
    queryId: '61012e26c8fa503aac68cc591452ffcf',
    pageSize: 50,
    extractPayload: ( response: ApiFetchResponse<SimplePages> ) => response?.data?.simplePageCatalog?.simple_pages,
    mapItem: ( p: SimplePageContent ): SimplePageContent => ( {
        id: p.id,
        title: p.title,
        slug: p.slug,
        body: p.body
    } )
};

export async function refreshSimplePagesFromServer(): Promise<SimplePageContent[]> {
    // Callers of this wrapper only want the records; partial-fetch handling lives in syncDependency.
    return ( await fetchFromServer( config ) ).items;
}

export async function refreshSimplePageCache(): Promise<boolean> {
    return syncDependency( config );
}
